module.exports = __webpack_public_path__ + "static/media/ic-pari-light.dde6527c.svg";